import { render } from "./SubscriptionPaymentData.vue?vue&type=template&id=2b20f4e8&scoped=true&ts=true"
import script from "./SubscriptionPaymentData.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPaymentData.vue?vue&type=script&lang=ts"

import "./SubscriptionPaymentData.vue?vue&type=style&index=0&id=2b20f4e8&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b20f4e8"]])

export default __exports__